<template>
  <div class="masonry">
    <div class="masonryHeader">
      <h1 v-if="title">{{ title }}</h1>
      <h1 v-else-if="activeMonthFormatted">{{ activeMonthFormatted }}</h1>

      <div class="columnSwitch">
        Columns: <a v-for="n in 6" :key="n" >
          <label :for="'column-' + n" :class="columns === n ? 'selected' : ''">
            <input v-model="columns" :id="'column-' + n" type="radio" @change="changeColumns()" :value="n" />{{n}}
          </label>
        </a>
      </div>
    </div>
    <div class="items" v-if="activeMedia" ref="columnContainer">
      <div class="item" v-for="(media, index) in activeMedia" :key="media.id">
        <span class="video" v-if="media.info.type && media.info.type === 'video'" v-on:click.prevent="launchLightbox(media, index)">
          <video playsinline>
            <source :src="getVideoSrc(media, false)" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </span>
        <span v-else>
          <a :href="getImageSrc(media)" v-on:click.prevent="launchLightbox(media, index)"><img class="masonryImage" v-bind:src="getImageSrc(media)" :alt="media.item_title" /></a>
        </span>
      </div>
    </div>
    <transition name="fade">
      <div class="lightbox" v-if="lightBoxActive">
        <div class="close"><button class="nobutton" @click="closeLightbox"><span class="screen-reader-only">Close</span><span aria-hidden="true">X</span></button></div>
        <div class="lightboxImageContainer">
          <div class="lightboxControl previous" v-if="prevItem">
            <a href="#" ref="prevClick" v-on:click.prevent="switchLightbox(prevItem, 'prev')">
              <span v-if="prevItem.info.type && prevItem.info.type === 'video'">
                <video :src="getVideoSrc(prevItem, 'lightboxVideo')" width="100%" playsinline>
                  <source :src="getVideoSrc(prevItem, 'lightboxVideo')">
                  Your browser does not support the video tag.
                </video>
              </span>
              <span v-else>
                <img :src="getImageSrc(prevItem)" :alt="prevItem.item_title" />
              </span>
            </a>
          </div>
          <div class="lightboxImageDiv" id="lightboxImageDiv" ref="lightboxImageDiv">
            <span v-if="activeItem.info.type && activeItem.info.type === 'video'">
              <video :src="getVideoSrc(activeItem, false)" ref="lightboxVideo" controls playsinline id="lightboxVideo">
                <source :src="getVideoSrc(activeItem, false)" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </span>
            <span v-else :style="ratioProperty + ':calc(100%)'">
              <img :src="getImageSrc(activeItem)" :alt="activeItem.item_title"  class="lightboxImage"  :style="ratioProperty + ':calc(100%)'" />
            </span>
          </div>
          <div class="lightboxControl next" v-if="nextItem">
            <a href="#" ref="nextClick" v-on:click.prevent="switchLightbox(nextItem, 'next')">
              <span v-if="nextItem.info.type && nextItem.info.type === 'video'">
                <video :src="getVideoSrc(nextItem, false)" width="100%" playsinline>
                  <source :src="getVideoSrc(nextItem, false)">
                  Your browser does not support the video tag.
                </video>
              </span>
              <span v-else>
                <img :src="getImageSrc(nextItem)" :alt="nextItem.item_title" />
              </span>
            </a>
          </div>
        </div>
        <div class="lightboxCaption">
          <div>
            {{ activeItem.item_title }}
          </div>
          <AdminOptions :item="activeItem" v-if="user" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import store from '@/store'
import {format as datefnsFormat} from 'date-fns'

import AdminOptions from "@/components/scrapbooks/AdminOptions.vue";

export default {
  name: 'component-masonry',
  components: {
    AdminOptions
  },
  props: ['title'],
  data () {
    return {
      imagesizes: {
        150: {
          folder: 'tiny'
        },
        300: {
          folder: 'thumb'
        },
        600: {
          folder: 'medium'
        },
        1300: {
          folder: 'large'
        }
      },
      columns: 4,
      imgSize: 'thumb',
      containerWidth: 992,
      largestImage: 300,
      lightBoxActive: false,
      activeItem: false,
      activeIndex: false,
      prevItem: false,
      nextItem: false,
      ratioProperty: 'height',
      imgCheck: false,
      loadAttempts: 0
    }
  },
  computed: {
    activeMonth () {
      return store.state.activeMonth
    },
    activeMonthFormatted () {
      if (!this.activeMonth) {
        return false
      }
      let m = this.activeMonth + '-02'
      return datefnsFormat(new Date(m), 'MMMM yyyy')
    },
    activeMedia () {
      return store.state.activeMedia
    },
    imageSize () {
      return this.containerWidth / this.columns
    },
    user () {
      return store.state.apiKey
    }
  },
  watch: {
    activeMedia () {
      let $this = this
      if (this.imgCheck) {
        clearInterval(this.imgCheck)
      }
      this.imgCheck = setInterval(function() {
        $this.checkMedia()
      }, 2000)
    }
  },
  created () {

  },
  mounted () {
    this.columns = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--masonry-columns'))
    this.calculateImageWidth()
    let $this = this
    document.onkeydown = function(evt) {
      evt = evt || window.event
      let isEscape = false
      let isNext = false
      let isPrev = false
      if ("key" in evt) {
          isEscape = (evt.key === "Escape" || evt.key === "Esc")
          isNext = (evt.key === "ArrowRight")
          isPrev = (evt.key === "ArrowLeft")
      } else {
          isEscape = (evt.keyCode === 27)
          isNext = (evt.keyCode === 39)
          isPrev = (evt.keyCode === 37)
      }
      if (isEscape) {
        $this.closeLightbox()
      }
      if (isNext) {
        $this.$refs.nextClick.click()
      }
      if (isPrev) {
        $this.$refs.prevClick.click()
      }
    }
  },
  methods: {
    getImageSrc (media) {
      let url = process.env.VUE_APP_API_PATH + '/images/' + this.imgSize + '/' + media.filename
      return url
    },
    getVideoSrc (media, id) {
      let url = process.env.VUE_APP_API_PATH + '/videos/' + media.filename

      // TODO: check for browsers - don't bother not on safari
      if (id) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function(e) {
          if (this.status == 200) {
            var myBlob = this.response;
            var vid = (window.webkitURL || window.URL).createObjectURL(myBlob);
            var video = document.getElementById(id);
            video.src = vid;
            document.getElementById(id).play()
           }
          }

        xhr.send();

      }


      return url
    },
    changeColumns () {
      let cols = parseInt(this.columns)
      if (cols > 6) {cols = 6}
      if (cols < 1) {cols = 1}
      document.documentElement.style.setProperty('--masonry-columns', cols)
      this.calculateImageWidth()
    },
    calculateImageWidth () {
      if (!this.$refs.columnContainer) {
        this.containerWidth = window.innerWidth - 32
      } else {
        this.containerWidth = this.$refs.columnContainer.clientWidth
      }
      document.documentElement.style.setProperty('--masonry-width', this.containerWidth + 'px')
      this.loadNewImages()
    },
    loadNewImages () {
      if (this.imageSize > this.largestImage) {
        for (var key in this.imagesizes) {
          if (this.imageSize < key) {
            this.imgSize = this.imagesizes[key].folder
            this.largestImage = key
            break
          }
        }
      }
    },
    launchLightbox (item, index) {
      this.lightBoxActive = true
      this.activeItem = item
      this.setNextPrev(index)
      this.activeIndex = index
      this.showLightboxItem(item)

    },
    setNextPrev(index) {
      this.$nextTick(() => {
        if (this.$refs.lightboxVideo) {
          this.$refs.lightboxVideo.pause()
        }

      })
      // PREV
      if (index > 0) {
        let prevIndex = index - 1
        this.prevItem = this.activeMedia[prevIndex]
      } else {
        this.prevItem = this.activeMedia[this.activeMedia.length - 1]
      }

      let nextIndex = index + 1
      if (this.activeMedia[nextIndex]) {
        this.nextItem = this.activeMedia[nextIndex]
      } else {
        this.nextItem = this.activeMedia[0]
      }
    },
    switchLightbox(item, direction) {
      let originalIndex = this.activeIndex
      let index = false
      if (direction == "next") {
        index = originalIndex + 1
        if (index === this.activeMedia.length) {
          index = 0
        }
      } else {
        index = originalIndex - 1
        if (index < 0) {
          index = this.activeMedia.length - 1
        }
      }
      this.activeIndex = index
      this.activeItem = item
      this.setNextPrev(index)
      this.showLightboxItem(item)
      console.log('switching')
      console.log(this.activeItem.item_title)
    },
    showLightboxItem (item) {
      this.calculateLightboxRatio(item)
      if (item.info && item.info.type && item.info.type === 'video') {
        this.$nextTick(() => {
          this.$refs.lightboxVideo.play()
        })
      }
    },
    calculateLightboxRatio (item) {
      if (item.info && item.info.whratio) {
        this.$nextTick(() => {
          let itemRatio = item.info.whratio
          let imageBox = this.$refs.lightboxImageDiv
          let boxRatio = imageBox.clientWidth / imageBox.clientHeight
          if (boxRatio > itemRatio) {
            this.ratioProperty = 'height'
          } else {
            this.ratioProperty = 'width'
          }
          let lightboxImages = document.getElementsByClassName("lightboxImage")
          for (let i = 0; i < lightboxImages.length; i++) {
            let imgWidth = lightboxImages[i].width
            if (imgWidth > this.largestImage) {
              for (var key in this.imagesizes) {
                if (imgWidth < key)  {
                  let imgSize = this.imagesizes[key].folder
                  lightboxImages[i].src = process.env.VUE_APP_API_PATH + '/images/' + imgSize + '/' + item.filename
                  break
                }
              }
            }
          }
        })
      }
    },
    closeLightbox () {
      this.lightBoxActive = false
    },
    addEvent (object, type, callback) {
      if (object == null || typeof(object) == 'undefined') return
      if (object.addEventListener) {
          object.addEventListener(type, callback, false)
      } else if (object.attachEvent) {
          object.attachEvent("on" + type, callback)
      } else {
          object["on"+type] = callback
      }
    },
    checkMedia () {
      this.loadAttempts++
      let images = document.getElementsByClassName('masonryImage')
      let num = 0
      console.log('checking images')
      for (let image of images) {
        if (image.clientHeight < 75) {
          num++
          image.src = image.src + ''
        }
      }
      if (num === 0 || this.loadAttempts > 7) {
        console.log('clearing interval')
        clearInterval(this.imgCheck)
        this.loadAttempts = 0
        this.imgCheck = false
      }
    }
  }
}
</script>

<style lang="scss">
  :root {
    --masonry-columns: 4;
    @media screen and (max-width: 600px) {
      --masonry-columns: 3;
    }
    @media screen and (max-width: 300px) {
      --masonry-columns: 2;
    }
    @media screen and (max-width: 100px) {
      --masonry-columns: 1;
    }

    --masonry-width: 1200px;
  }

  .columnSwitch {
    > a {
      margin-left: 5px;
      margin-right: 5px;
    }
    input {
      display: none;
    }
    label {
      color: $brandGrey;
      transition: all .25s;
      &.selected {
        color: $brandLightGreen;
        font-size: 1.6rem;
      }
    }
  }

  .masonry {

    .items {
      margin: 0 1rem;
      column-count: var(--masonry-columns);
      column-gap: 1rem;
      column-count: 6;
      column-width: calc((var(--masonry-width) - (1rem * (var(--masonry-columns) - 1))) / var(--masonry-columns));

      transition: all .25s;
      .item {
        margin: 0 0 1rem;
        span.video {
          position: relative;
          display: block;
          &::after {
            content: "\25BA"; // ::before and ::after both require content
            position: absolute;
            display:flex;
            flex-direction:row;
            align-items: center;
            justify-content: center;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            color: $brandLightGreen;
            background-color: rgba(0, 0, 0, .5);
          }
        }
        img {
          display: block;
          margin: auto;
          width: 100%;
        }
        video {
          max-width: 100%;
          display: block;
          margin: auto;

        }
      }
    }
  }
  .masonryHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 1rem;
    flex-wrap: wrap;
    > * {
      max-width: 400px
    }
  }

  .lightbox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $brandBlack80;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .close {
      align-self: flex-end;
    }
    .nobutton {
      color: $brandGrey;
      font-size: 2.0rem;
      cursor: pointer;
    }
  }
  .lightboxImageContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: calc(100% - 90px);
    margin-top: 20px;
  }
  .lightboxImageDiv {
    flex-grow: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img, video {
      display: block;
      margin: auto;
      max-height: 100%;
      max-width: 100%;
      // border: 10px solid $brandGreen;
    }
  }
  .lightboxControl {
    width: 75px;
    height: 75px;
    position: fixed;
    top: calc(50% - (75px/2));
    img, video {
      width: 100%;
      height: 100%;
      border: 10px solid $brandGreen;
      object-fit: cover;

    }
    &.previous {
      left: 0;
      z-index: 500;
      img, video {
        object-position: right;
        border-left: none;

      }
    }
    &.next {
      right: 0;
      z-index: 500;
      img, video {
        object-position: left;
        border-right: none;

      }
    }
  }
  .lightboxCaption {
    height: 70px;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>
